import React from 'react';

import { Checkbox, Typography as AntdTypo } from 'antd';

import { UserDtoProfileEnum } from 'lib_api/lib/api/gen';

import BaseForm from 'components/BaseForm/BaseForm';
import BaseSelect from 'components/BaseForm/Select/BaseSelect';
import BaseSelectWithSearch from 'components/BaseForm/Select/BaseSelectWithSearch';
import { profilesWithUniteRattachement } from 'components/Comptes/common';
import { useUserStore } from 'hooks/UserStoreContext';
import { userMapping } from 'utils/enumData';

import { FilterDashboardComptesUtilisateurs } from '../../DashboardHeader/types';

import { FormFooter } from './FormFooter/FormFooter';
import { FilterComptesUtilisateursProps } from './types';
import useUniteRattachement from './useUniteRattachement';

export default function AdvancedSearchForm({
  filter,
  setFilter,
}: FilterComptesUtilisateursProps): React.ReactElement {
  const user = useUserStore();
  const fieldUserTypeDisabled =
    user.profile !== UserDtoProfileEnum.ADMIN_FONCTIONNEL;

  const [selectedProfile, setSelectedProfile] = React.useState<
    UserDtoProfileEnum | undefined
  >(filter.userType);

  function isUniteRattachementDisabled(
    profile: UserDtoProfileEnum | undefined,
  ): boolean {
    return (
      profile === undefined ||
      !profilesWithUniteRattachement.has(profile) ||
      user.profile !== UserDtoProfileEnum.ADMIN_FONCTIONNEL
    );
  }

  const asyncSearchUniteRattachement = useUniteRattachement(selectedProfile);

  function onFormChange() {
    return (
      changed: Partial<Partial<FilterDashboardComptesUtilisateurs>>,
      all: Partial<FilterDashboardComptesUtilisateurs>,
    ) => {
      if (
        changed.userType !== undefined &&
        changed.userType !== selectedProfile
      ) {
        all.entiteRattachement = undefined;
        filter.entiteRattachement = undefined;
        setSelectedProfile(changed.userType);
      }

      return {
        ...all,
      };
    };
  }

  return (
    <>
      <AntdTypo.Title level={3}>Recherche avancée</AntdTypo.Title>
      <BaseForm
        initialValues={filter}
        onChange={onFormChange()}
        inputs={[
          {
            name: 'lastName',
            label: 'Nom',
          },
          {
            name: 'firstName',
            label: 'Prénom',
          },
          {
            name: 'email',
            label: 'Adresse e-mail',
          },
          {
            name: 'username',
            label: 'Identifiant',
          },
          {
            name: 'userType',
            label: 'Profil',
            render: () => (
              <BaseSelect
                disabled={fieldUserTypeDisabled}
                options={[
                  UserDtoProfileEnum.DSR_BLR,
                  UserDtoProfileEnum.FORCE_DE_L_ORDRE,
                  UserDtoProfileEnum.GARDIEN_FOURRIERE,
                  UserDtoProfileEnum.AUTORITE_FOURRIERE,
                  UserDtoProfileEnum.ADMIN_FONCTIONNEL,
                ]}
                getOptionValue={option => option.toString()}
                getOptionLabel={option => userMapping[option]}
              />
            ),
          },
          {
            name: 'entiteRattachement',
            label: 'Entité de rattachement',
            render: () => (
              <BaseSelectWithSearch
                key={selectedProfile}
                allowClear
                defaultValue={filter.entiteRattachement}
                disabled={isUniteRattachementDisabled(selectedProfile)}
                useSearchEntities={asyncSearchUniteRattachement}
                getOptionValue={option => option.value}
                getOptionLabel={option => option.displayValue}
              />
            ),
          },
          {
            name: 'gestionnaireLocal',
            label: 'Gestionnaire Local',
            valuePropName: 'checked',
            render: () => <Checkbox />,
          },
        ]}
        onSubmit={() => Promise.resolve()}
        renderButtonAction={() => (
          <FormFooter
            setFilter={setFilter}
            userProfile={user.profile}
            filter={filter}
          />
        )}
      />
    </>
  );
}
